/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateUserRequisitesRequest { 
    organizationTypeId?: number | null;
    inn?: string | null;
    kpp?: string | null;
    taxOfficeCode?: string | null;
}

